const Liked = () => {
  return (
    <svg width="18" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6 0C11.217 0 9.955.53 9 1.404A5.318 5.318 0 0 0 5.4 0C2.418 0 0 2.468 0 5.514c0 4.444 4.48 8.74 8.62 11.245.21.133.553.131.762-.001C13.495 14.243 18 9.958 18 5.514 18 2.468 15.582 0 12.6 0ZM9.005 14.825C4.555 11.855 1.8 8.385 1.8 5.514c0-2.03 1.612-3.676 3.6-3.676.9 0 1.743.336 2.4.935l.866.792a.502.502 0 0 0 .668 0l.866-.792c.657-.6 1.5-.935 2.4-.935 1.988 0 3.6 1.645 3.6 3.676 0 2.944-2.744 6.34-7.195 9.311Z"
        fill="#fff"
      />
    </svg>
  );
};

export default Liked;
